import {
  Button,
  Icons,
  Placeholder,
  notify,
  HexIcon,
  Typography,
  Stack,
} from '@cast/design-system';
import { useMarkSalesContactedMutation } from '@cast/shared-trial-data-access';

import { Link as RouterLink } from 'components/router';
import { openScheduleDialog } from 'core/integrations';

type Props = {
  name: string;
  description?: string;
  docs?: {
    text?: string;
    link: string;
  };
};

export const UnblockPremiumFeature = ({ name, description, docs }: Props) => {
  const { mutate: markSalesContacted } = useMarkSalesContactedMutation();

  const handleScheduleCall = () => {
    openScheduleDialog({
      onMeetingBooked: () => {
        markSalesContacted();
      },
      onError: () =>
        notify.error(
          'Failed to load the booking form. Please try again later.'
        ),
    });
  };

  return (
    <Stack width="100%" alignItems="center">
      <Placeholder
        stackProps={{ mt: 32 }}
        icon={
          <HexIcon
            variant="notification"
            icon={<Icons.EyeSlash weight="fill" />}
            size={80}
          />
        }
        sx={{
          width: '644px',
        }}
        iconWrapperProps={{ mb: 8 }}
        title={`${name} is a premium feature`}
        titleProps={{ variant: 'h5' }}
        body={
          <Stack alignItems="center" gap={24}>
            <Stack alignItems="center" gap={32}>
              <Stack alignItems="center" gap={16}>
                {description && (
                  <Typography variant="P14R">{description}</Typography>
                )}

                <Button
                  startIcon={<Icons.CalendarBlank />}
                  onClick={handleScheduleCall}
                >
                  Talk to us to upgrade
                </Button>
              </Stack>

              {docs && (
                <Button
                  size="lg"
                  variant="text"
                  startIcon={<Icons.Book />}
                  component={RouterLink}
                  to={docs.link}
                  rel="noopener noreferrer"
                  target="_blank"
                  data-testid="docs-button"
                >
                  {docs.text ? docs.text : `${name} documentation`}
                </Button>
              )}
            </Stack>
          </Stack>
        }
        bodyProps={{ mt: '4px', component: 'div' }}
        testId="unblock-premium-feature"
      />
    </Stack>
  );
};
